// import { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { Navigate, Outlet, useLocation } from "react-router-dom";

// // import { flat } from "@utils";
// import { protectedRoutes } from "app/routes";

// import GullLayout from "app/layouts/GullLayout";
// import AccessDenied from "app/views/sessions/AccessDenied";


// const userHasPermission = (pathname, user, routes) => {
//   if (!user) {
//     return false;
//   }

//   const matched = routes.find((r) => r.path === pathname);
//   return matched && matched.auth && matched.auth.length ? matched.auth.includes(user.role) : true;
// };

// export default function AuthGuard() {

//   const { pathname } = useLocation();
//   const [previousRoute, setPreviousRoute] = useState(null);
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   let hasPermission = userHasPermission(pathname, user, protectedRoutes);

//   useEffect(() => {
//     if (previousRoute !== null) setPreviousRoute(pathname);
//   }, [pathname, previousRoute]);

//   return (
//     <>
//       {isAuthenticated && hasPermission ? (
//         <GullLayout>
//           <Outlet />
//         </GullLayout>
//       ) : (
//         <>
//           {isAuthenticated && !hasPermission ? (
//             <AccessDenied />
//           ) : (
//             <Navigate to={previousRoute || "/sessions/signin"} replace={true} />
//           )}
//         </>
//       )}
//     </>
//   );
// }



import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { protectedRoutes } from "app/routes";
import GullLayout from "app/layouts/GullLayout";
import AccessDenied from "app/views/sessions/AccessDenied";

// 🔐 Permission check
const userHasPermission = (pathname, user, routes) => {
  if (!user) return false;

  const role = (user.role || "").toString().toLowerCase();
  const isSuperuser =
    user.is_superuser === true ||
    user.is_superuser === "true" ||
    user.is_superuser === 1 ||
    user.is_superuser === "1" ||
    role === "superuser" ||
    role === "sa";

  if (isSuperuser) {
    return true;
  }

  const matched = routes.find((r) =>
    pathname.startsWith(r.path)
  );

  if (!matched || !matched.auth) return true;

  return matched.auth
    .map((allowedRole) => allowedRole.toString().toLowerCase())
    .includes(role);
};

export default function AuthGuard() {
  const { pathname } = useLocation();
  const [previousRoute, setPreviousRoute] = useState(null);

  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const hasPermission = userHasPermission(
    pathname,
    user,
    protectedRoutes
  );

  // track last route
  useEffect(() => {
    if (pathname !== "/sessions/signin") {
      setPreviousRoute(pathname);
    }
  }, [pathname]);

  // 🚪 NOT LOGGED IN → redirect to login
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/sessions/signin"
        replace
      />
    );
  }

  const normalizedRole = (user?.role || "").toString().toLowerCase();
  const isSuperuser =
    user?.is_superuser === true ||
    user?.is_superuser === "true" ||
    user?.is_superuser === 1 ||
    user?.is_superuser === "1" ||
    normalizedRole === "superuser" ||
    normalizedRole === "sa";

  if (!isSuperuser) {
    return <AccessDenied />;
  }

  if (!hasPermission) {
    return <AccessDenied />;
  }

  return (
    <GullLayout>
      <Outlet />
    </GullLayout>
  );
}